export interface IAdobeDTM {
	trackState: Partial<
		{
			"page.legacyName": string;
			"page.state": string;
			"baseball.matchupDate": string;
		} & unknown &
			Record<string, string | number | Date>
	>;
	trackAction: Partial<
		{
			"action.location": string;
			"action.name": string;
			"action.category": string;
			"action.element.text": string;
			"action.options": string;
		} & unknown &
			Record<string, string | number | Date>
	>;
}

export abstract class AdobeDTM {
	public static trackState(params: IAdobeDTM["trackState"]) {
		try {
			console.log(params);
			window._satellite?.track("trackState", params);
		} catch (e) {
			console.log(e);
		}
	}

	public static trackAction(params: IAdobeDTM["trackAction"]) {
		try {
			console.log(params);
			window._satellite?.track("trackAction", {
				"action.location": "Major League Baseball: Spinball",
				"action.category": "Spinball",
				...params,
			});
		} catch (e) {
			console.log(e);
		}
	}

	public static appendParamsToLink(location: string, isNative: boolean) {
		try {
			const url = new URL(window._satellite.getVisitorId().appendVisitorIDsTo(location));

			return url.toString();
		} catch (e) {
			console.log(e);
		}

		return location;
	}
}
